var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{staticClass:"role-user-list",attrs:{"size":"small","title":_vm.$t('page_role_management_user_group_members')}},[_c('ml-directory',{attrs:{"dataSource":_vm.userList,"acls":{
      add: 'page_role_management_create_member',
      delete: 'page_role_management_delete_member',
    },"suffix":{
      label: _vm.$t('page_role_management_add_member'),
    },"resetFields":{
      picture: 'avatar',
    },"defaultPic":require('@/assets/images/avatar.png')},on:{"delete":function (item) { return _vm.removeUser(item.id); },"add":_vm.createUser}}),_c('user-list-modal',{attrs:{"visible":_vm.userListModalVisible},on:{"ok":function($event){return _vm.handlerOk($event)},"cancel":function($event){_vm.userListModalVisible = false}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }